import React, { useState, useContext } from "react";
import BuilderComponent from "./BuilderComponent";
import { BuilderContext } from "../BuilderContext";
import { useEffect } from "react";

const BuilderComponentList = ({
  builderId,
  builderDetails,
  builderComponentDetails,
  editPage,
  setUpdatedBuilderDetails,
  setBuilderPreview,
  setShowPreview,
  preview_builder_Details,
}) => {
  const builderContextData = useContext(BuilderContext);
  const { component_template } = builderContextData;
  const [componentList, setComponentList] = useState(builderComponentDetails);

  const add_component_tolist = async () => {
    const component_template_val = {
      ...component_template,
      rank: componentList.length + 1,
    };
    const tempComponentList = [...componentList, component_template_val];
    setComponentList(tempComponentList);
    setUpdatedBuilderDetails({
      ...builderDetails,
      components: tempComponentList,
    });
  };

  useEffect(() => {
    setComponentList(builderComponentDetails);
  }, [builderComponentDetails]);

  const updateComponentList = (newItem, pos) => {
    let updatedComponentListdata = [];
    for (let index in componentList) {
      if (parseInt(index) === pos) {
        if (newItem) {
          updatedComponentListdata.push(newItem);
        }
      } else {
        updatedComponentListdata.push(componentList[index]);
      }
    }
    setComponentList(updatedComponentListdata);
    setUpdatedBuilderDetails({
      ...builderDetails,
      components: updatedComponentListdata,
    });
  };

  const removeComponentFromList = (pos) => {
    let updatedComponentList = [...componentList];
    updatedComponentList?.splice(pos, 1);
    setComponentList(updatedComponentList);
    setUpdatedBuilderDetails({
      ...builderDetails,
      components: updatedComponentList,
    });
  };


  const reorderComponent = async (pos1, pos2) => {
    let updatedComponentListdata = [];
    for (let index in componentList) {
      if (parseInt(index) === pos1) {
        updatedComponentListdata.push(componentList[pos2]);
      } else if (parseInt(index) === pos2) {
        updatedComponentListdata.push(componentList[pos1]);
      } else {
        updatedComponentListdata.push(componentList[index]);
      }
    }
    for (let index in updatedComponentListdata) {
      updatedComponentListdata[index].rank = parseInt(index) + 1;
    }
    setComponentList(updatedComponentListdata);
    setUpdatedBuilderDetails({
      ...builderDetails,
      components: updatedComponentListdata,
    });
  };

  return (
    <React.Fragment>
      <div className="container-fluid pe-3 ps-4">
        {componentList &&
          componentList.map((item, index) => {
            return (
              <BuilderComponent
                builderId={builderId}
                componentdetail={item}
                position={index}
                editPage={editPage}
                key={index}
                updateComponentList={updateComponentList}
                removeComponentFromList={removeComponentFromList}
                totalComponent={componentList.length}
                reorderComponent={reorderComponent}
                preview_builder_Details={preview_builder_Details}
                setComponentList={setComponentList}
                componentList={componentList}
              />
            );
          })}
        <div className="col-2" style={{}}>
          <button
            data-testid="builder-component-list-btn"
            className="btn fst-normal shadow-none"
            style={{
              border: "1px solid #091caa",
              color: "#091caa",
              backgroundColor: "white",
            }}
            onClick={add_component_tolist}
          >
            Add Component
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};
export default BuilderComponentList;
